import { Action, createReducer, on } from '@ngrx/store';
import { PayRateState } from './state/pay-rate.state';
import {
    getBillingPayRatesSuccess,
    getBillingPayRatesFailure,
    updateBillingPayRatesFailure,
    getShiftDiffLookupSuccess,
    getShiftDiffLookupFailure,
    getIncentivePayRatesSuccess,
    updateIncentivePayRatesFailure,
    payRatesUpdatedMessageSuccess,
    payRatesUpdatedMessageFailure,
    updateBillingPayRatesSuccessNoUpdate,
    setFacilityId,
    incentivePayRatesUpdatedMessageSuccess,
    incentivePayRatesUpdatedMessageFailure,
    setFetchArgs,
    updateIncentivePayRatesSuccessNoUpdate,
    incentivePayRatesUpdatingMessageSuccess,
    payRatesUpdatingMessageSuccess,
    payRatesUpdatingMessageFailure,
    incentivePayRatesUpdatingMessageFailure
} from './actions/pay-rate.actions';

export const payrateFeatureKey = 'pay-rate';

export const initialState: PayRateState = {
    billingRates: undefined,
    incentiveRates: undefined,
    shiftDifferentialTypes: undefined,
    facilityId: undefined,
    facilitySystemId: undefined,
    lastFetchArgs: undefined,
    signalRLoading: undefined,
    error: undefined
};

const PayRateReducer = createReducer(
    initialState,

    on(getBillingPayRatesSuccess, (state, action) => ({
        ...state,
        billingRates: action.billingRates,
        signalRLoading: false,
        error: undefined
    })),
    on(getIncentivePayRatesSuccess, (state, action) => ({
        ...state,
        incentiveRates: action.incentiveRates,
        signalRLoading: false,
        error: undefined
    })),
    on(getBillingPayRatesFailure, (state, action) => ({
        ...state,
        billingRates: null,
        signalRLoading: false,
        error: action.error
    })),
    on(getShiftDiffLookupSuccess, (state, action) => ({
        ...state,
        shiftDifferentialTypes: action.shiftDifferentialTypes,
        error: undefined
    })),
    on(getShiftDiffLookupFailure, (state, action) => ({
        ...state,
        shiftDifferentialTypes: undefined,
        error: action.error
    })),
    on(updateBillingPayRatesSuccessNoUpdate, (state, action) => ({
        ...state,
        error: undefined
    })),
    on(updateIncentivePayRatesSuccessNoUpdate, (state, action) => ({
        ...state,
        error: undefined
    })),
    on(updateBillingPayRatesFailure, (state, action) => ({
        ...state,
        error: action.error
    })),
    on(updateIncentivePayRatesFailure, (state, action) => ({
        ...state,
        error: action.error
    })),
    on(payRatesUpdatedMessageSuccess, (state, action) => ({
        ...state,
        error: undefined
    })),
    on(payRatesUpdatedMessageFailure, (state, action) => ({
        ...state,
        error: action.error
    })),
    on(incentivePayRatesUpdatedMessageSuccess, (state, action) => ({
        ...state,
        error: undefined
    })),
    on(incentivePayRatesUpdatedMessageFailure, (state, action) => ({
        ...state,
        error: action.error
    })),
    on(setFacilityId, (state, action) => ({
        ...state,
        facilityId: action.facilityId,
        facilitySystemId: action.facilitySystemId
    })),
    on(setFetchArgs, (state, action) => ({
        ...state,
        lastFetchArgs: action.args
    })),
    on(payRatesUpdatingMessageSuccess, (state, action) => ({
        ...state,
        signalRLoading: true,
        error: undefined
    })),
    on(payRatesUpdatingMessageFailure, (state, action) => ({
        ...state,
        signalRLoading: false,
        error: action.error
    })),
    on(incentivePayRatesUpdatingMessageSuccess, (state, action) => ({
        ...state,
        signalRLoading: true,
        error: undefined
    })),
    on(incentivePayRatesUpdatingMessageFailure, (state, action) => ({
        ...state,
        signalRLoading: false,
        error: action.error
    }))
);

export function payRateReducer(state: PayRateState | undefined, action: Action) {
    return PayRateReducer(state, action);
}
